export enum EPillar {
    CRESCER = '1',
    CONECTAR = '2',
    INFLUENCIAR = '3',
    INSPIRAR = '4',
}